import { Breadcrumbs, BreadcrumbsProps, Stack, Typography } from '@mui/material'

import Image from 'components/core/image/index'
import { C1Link } from 'components/core/links/C1Link'
import { Route, routes } from 'lib/routes'
import image from 'public/static/c1-icon-light.svg'
import React, { FC } from 'react'

export type C1BreadcrumbsProps = BreadcrumbsProps & {
  breadcrumbs: (C1BreadcrumbLinkProps | false)[]
}

export type C1BreadcrumbLinkProps = {
    text: React.ReactNode
    href: Route
}

export const C1Breadcrumbs: FC<C1BreadcrumbsProps> = ({ breadcrumbs, ...props }) => (
    <Breadcrumbs {...props}>
        <C1LogoBreadcrumb />
        {breadcrumbs.map((crumb) => crumb && <C1Link href={crumb.href} key={crumb.href}>
            <Typography sx={{ color: 'text.primary' }}>{crumb.text}</Typography>
        </C1Link>)}
    </Breadcrumbs>
)

export const C1LogoBreadcrumb: FC = () => <C1Link href={routes.home}>
    <Stack sx={{ borderRadius: 1, backgroundColor: 'brand.main', height: 20, width: 20 }} alignItems="center" justifyContent="center">
        <Image alt="ConductorOne" src={image.src} height={12} width={12} />
    </Stack>
</C1Link>
